import React, { useEffect, useRef, useState, useMemo } from "react";
import { Collapse, Divider } from "antd";
import { SimpleLoader } from "./sub/Loaders";
import TopPlanElement from "./TopPlanElement";

const { Panel } = Collapse;

function StrategyGroupedPlanCards(props) {
  const BottomRef = useRef(null);
  const [activeKeys, setActiveKeys] = useState([]);

  // Group plans by strategy
  const groupedPlans = useMemo(() => {
    if (!props.data?.length) return {};
    
    const groups = {};
    
    props.data.forEach((plan) => {
      const strategyKey = plan.strategyId 
        ? `strategy-${plan.strategyId}` 
        : 'no-strategy';
      
      if (!groups[strategyKey]) {
        groups[strategyKey] = {
          strategy: plan.strategy || null,
          plans: []
        };
      }
      
      groups[strategyKey].plans.push(plan);
    });
    
    return groups;
  }, [props.data]);

  // Initialize active keys to show all strategy groups by default
  useEffect(() => {
    const keys = Object.keys(groupedPlans);
    setActiveKeys(keys);
  }, [groupedPlans]);

  useEffect(() => {
    if (props.data?.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            !props.loading &&
            props.totalTopPlanCount > props.data.length
          ) {
            props.setStartAt(props.startAt + 20);
            props.loadMore(props.startAt + 20);
          }
        });
      });
      observer.observe(BottomRef.current);
      return () => observer.disconnect();
    }
  }, [props]);

  const renderStrategyGroup = (strategyKey, group) => {
    const strategyName = group.strategy?.name || "No Strategy Assigned";
    const planCount = group.plans.length;
    
    return (
      <Panel
        header={
          <div className="flex justify-between items-center w-full">
            <div className="font-medium text-base">
              {strategyName}
            </div>
            <div className="text-sm text-gray-500">
              {planCount} plan{planCount !== 1 ? 's' : ''}
            </div>
          </div>
        }
        key={strategyKey}
      >
        <div className="space-y-4">
          {group.plans.map((plan, index) => (
            <TopPlanElement
              key={plan.planId}
              plans={group.plans}
              data={plan}
              handleDelete={props.handleDelete}
              handleEdit={props.handleEdit}
            />
          ))}
        </div>
      </Panel>
    );
  };

  if (!Object.keys(groupedPlans).length && !props.loading) {
    return <div className="text-center text-gray-500 py-8">No plans available</div>;
  }

  return (
    <>
      <Collapse
        activeKey={activeKeys}
        onChange={setActiveKeys}
        bordered={false}
        className="strategy-grouped-plans"
      >
        {Object.entries(groupedPlans).map(([strategyKey, group]) =>
          renderStrategyGroup(strategyKey, group)
        )}
      </Collapse>
      
      {/* Intersection observer target for infinite scroll */}
      <div ref={BottomRef} />
      
      {props.loading && <SimpleLoader />}
    </>
  );
}

export default StrategyGroupedPlanCards;
